import Splide from '@splidejs/splide';
require('fslightbox')
document.addEventListener("DOMContentLoaded", function () {
	initSlider(document.querySelector('.product-detail .detail-slider .splide'))
})

function initSlider(slider) {
	if (slider) {
		new Splide(slider, {
				breakpoints: {
					768: {
						// TODO скрыть стрелки через скрипт
						arrows: false,
					},
				}
			})
			.mount()
	}
}
